import { DialogActions as MuiDialogActions } from 'transfix-ui/core'
import { withStyles } from 'transfix-ui/core/styles'

export const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(4),

    /**
     * Remove some of the padding on mobile
     */
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(2),
    },
  },
}))(MuiDialogActions)
